import SimpleErrorMessage from './SimpleErrorMessage';

export default SimpleErrorMessage;